<div class="fixed inset-0 z-50 pointer-events-none">
	<div *ngFor="let modal of modals"
		class="fixed inset-0 bg-[#00000040] flex items-center justify-center pointer-events-auto animate-fadeIn"
		(click)="onBackdropClick($event, modal.id)">
		<div
			class="bg-white rounded-lg shadow-2xl max-w-[90vw] max-h-[90vh] overflow-hidden animate-slideIn pointer-events-auto"
			[style.width]="modal.config.width || '500px'" [style.height]="modal.config.height || 'auto'">

			@if (modal.config.title) {
			<!-- Header du modal -->
			<div class="flex justify-between items-center px-3 py-2 border-b border-gray-100"
				*ngIf="modal.config.title || modal.config.closable !== false">
				<h4 *ngIf="modal.config.title" class="!text-[16px] font-medium text-gray-900 m-0">
					{{ modal.config.title }}
				</h4>
				<button *ngIf="modal.config.closable !== false"
					class="bg-transparent border-none text-2xl cursor-pointer text-gray-400 p-1 rounded transition-colors hover:text-red-600"
					(click)="closeModal(modal.id)">
					×
				</button>
			</div>
			}

			<!-- Contenu du modal -->
			<div class="p-3 overflow-y-auto max-h-[calc(90vh-120px)]">
				<ng-container *ngComponentOutlet="modal.config.component">
				</ng-container>
			</div>
		</div>
	</div>
</div>